import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { isRangeSelectionDatePicker } from '../utils/helper';
export const DatepickerContext = /*#__PURE__*/React.createContext();
export function DatepickerProvider(props) {
  const {
    type,
    month,
    isOpen,
    locale,
    children,
    withInput,
    setIsOpen,
    dateFormat,
    handleOnClose,
    handleResetClick,
    placeholder,
    setDisableConfirmButton,
    setMonth
  } = props;
  const datepickerContainerRef = useRef(null);
  const datepickerTriggerRef = useRef(null);
  const isRangeDatePicker = isRangeSelectionDatePicker(type);
  return /*#__PURE__*/React.createElement(DatepickerContext.Provider, {
    value: {
      type,
      month,
      isOpen,
      locale,
      withInput,
      setIsOpen,
      dateFormat,
      handleOnClose,
      handleResetClick,
      isRangeDatePicker,
      setDisableConfirmButton,
      datepickerContainerRef,
      datepickerTriggerRef,
      placeholder,
      setMonth
    }
  }, children);
}
DatepickerProvider.propTypes = {
  type: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  handleOnClose: PropTypes.func.isRequired,
  month: PropTypes.instanceOf(Date),
  handleResetClick: PropTypes.func.isRequired,
  setDisableConfirmButton: PropTypes.func.isRequired,
  dateFormat: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  withInput: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  placeholder: PropTypes.string,
  setMonth: function (props, propName) {
    if (props['type'] && isRangeSelectionDatePicker(props['type']) && typeof props[propName] !== 'function') {
      return new Error(`prop ${propName} type of function must be supplied when using range picker.`);
    }
  }
};